// eslint-disable-next-line no-useless-rename
export { default as default } from "./AccessControl";
